import { USER_COUNTRY, USER_COUNTRY_PHONE_CODE, USER_MOBILE_NUMBER } from "~/utils/constant";

export const getLocalStorage = (key: string) => {
  if (typeof window === "undefined") return;
  return JSON.parse(localStorage.getItem(key) || "null");
};

export const setLocalStorage = (key: string, value: string) => {
  if (typeof window === "undefined") return;
  return localStorage.setItem(key, JSON.stringify(value));
};

export const removeItemFromLocalStorage = (key: string) => {
  return localStorage.removeItem(key);
};

export interface RemoveUserLoginKeyFromLocalStorage {
  (): void;
}

export const removeUserLoginKeyFromLocalStorage: RemoveUserLoginKeyFromLocalStorage = () => {
  return localStorage.removeItem(USER_MOBILE_NUMBER), localStorage.removeItem(USER_COUNTRY), localStorage.removeItem(USER_COUNTRY_PHONE_CODE);
};
